import React, { Component } from 'react';
import APIService from '../services/APIService';
import {
    Grid,
    Typography,
    TextField,
    Button,
    MenuItem
} from '@material-ui/core';
import AppContext from '../AppContext';
import PaddedGrid from '../components/PaddedGrid';
import Moment from 'moment';
import ReportStarter from '../components/ReportStarter';
import Loading from '../components/Loading';
import ReportsList from '../components/ReportsList';
import { withTranslation } from 'react-i18next';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            restaurant: {},
            organisation: {},
            restaurants: [],
            filterRestaurant: null,
            reports: [],
            totalMissedReportCount: 0,
            totalReportCount: 0,
            reportsFilters: {
                displayCount: 10,
                displayCountMissed: 10,
                start_date: null,
                end_date: null,
                restaurantId: false,
                pageNumber: 0,
                missedPageNumber: 0,
            },
            reports_missed: [],
            report: null, // Today's report
            error: null,
            loading: true
        };

        this.sortReports = this.sortReports.bind(this);
    }

    renderMissedReports() {
        if (this.state.reports_missed.length == 0)
            return;

        return (
            <Grid item xs={12}>
                <Typography variant="title">{this.props.t('Aloittamattomat Raportit')}</Typography>
                <ReportsList
                    page={this.state.reportsFilters.missedPageNumber}
                    color="#FF0000"
                    reports={this.state.reports_missed}
                    rowsPerPage={this.state.reportsFilters.displayCountMissed}
                    totalReportsCount={this.state.totalMissedReportCount}
                    reportsToDisplay={this.state.reportsFilters.displayCountMissed}
                    onReportsToDisplayChange={this.onReportsToDisplayChange.bind(this, true)}
                    changePageNumber={this.changePageNumber.bind(this, true)}
                />
            </Grid>
        );
    }

    sortReports(reports, missedReports) {
        reports.sort((a, b) => {
            return (a.date > b.date) ? -1 : 1;
        });

        const today = new Moment().startOf('day');
        const report = [...missedReports, ...reports].find((report) => today.isSame(new Moment(report.date)));

        // Material ui table pagination expects all pages before to have data...
        // When page changed, this adds new empty data to reports to fill out pages before
        const { pageNumber, displayCount, missedPageNumber, displayCountMissed } = this.state.reportsFilters;
        const num = pageNumber * displayCount;
        for (let i = 0; i < num; i++) {
            reports.unshift({});
        }

        const numMissed = missedPageNumber * displayCountMissed;
        for (let i = 0; i < numMissed; i++) {
            missedReports.unshift({});
        }

        this.setState({
            reports: reports,
            reports_missed: missedReports,
            report
        });
    }

    filterReports() {
        this.setState({ loading: true });
        let apiService = null;

        if (AppContext.isAdmin()) {
            apiService = APIService.getAllReports(this.state.reportsFilters);
        } else if (AppContext.isOrganisation()) {
            apiService = APIService.getOrganisationReports(this.state.user.organisation.id, this.state.reportsFilters);
        } else if (this.state.user.restaurant) {
            apiService = APIService.getReports(this.state.user.restaurant.id, this.state.reportsFilters);
        }
        apiService
            .then(reportData => {
                this.allReports = reportData.reports;
                this.sortReports(reportData.reports, reportData.missed_reports);
                this.setState({
                    totalReportCount: reportData.totalAmount,
                    totalMissedReportCount: reportData.totalMissedAmount,
                    loading: false
                });
            });
    }

    componentDidMount() {
        AppContext.getUser()
            .then(user => {
                this.setState({
                    user
                });

                if (AppContext.isAdmin()) {
                    return APIService.getAllReports(this.state.reportsFilters);
                } else if (AppContext.isOrganisation()) {
                    return APIService.getOrganisationReports(user.organisation.id, this.state.reportsFilters);
                } else if (user.restaurant) {
                    return APIService.getReports(user.restaurant.id, this.state.reportsFilters);
                }
            }).then(reportData => {
                this.allReports = reportData.reports;
                this.sortReports(reportData.reports, reportData.missed_reports);

                this.setState({ totalReportCount: reportData.totalAmount });
                this.setState({ totalMissedReportCount: reportData.totalMissedAmount });

                if (AppContext.isAdmin() || AppContext.isOrganisation()) {
                    return APIService.getRestaurants();
                } else {
                    return [];
                }
            }).then(restaurants => {
                this.setState({ restaurants, loading: false });
            }).catch((e) => {
                this.setState({
                    loading: false,
                    error: this.props.t('Raporttien tuonti epäonnistui')
                });

                AppContext.toast(this.props.t('Raporttien tuonti epäonnistui'));
            });
    }

    onReportsToDisplayChange(missedReports = false, count) {
        const key = missedReports ? 'displayCountMissed' : 'displayCount';

        this.setState(prevState => ({
            reportsFilters: {
                ...prevState.reportsFilters,
                [key]: count
            },
            loading: true,
        }), this.filterReports);
    }

    changePageNumber(missedReports = false, page) {
        const key = missedReports ? 'missedPageNumber' : 'pageNumber';

        this.setState(prevState => ({
            reportsFilters: {
                ...prevState.reportsFilters,
                [key]: page
            },
            loading: true,
        }), this.filterReports);
    }

    render() {
        if (this.state.loading) {
            return <Loading />;
        }

        let reportStarter = '';
        if (AppContext.isUser()) {
            reportStarter = <ReportStarter report={this.state.report} />;
        }

        let reportFinder = '';
        reportFinder = (
            <div style={{ padding: '10px', flex: 1 }}>
                <Typography variant="title" gutterBottom>{this.props.t('Etsi hävikkilomakkeita')}</Typography>

                <Grid container spacing={24}>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            type="date"
                            label={this.props.t('Aloituspäivä')}
                            value={this.state.reportsFilters.start_date}
                            onChange={(event) => {
                                const value = event.target.value;
                                this.setState(prevState => {
                                    let reportsFilters = Object.assign({}, prevState.reportsFilters);
                                    reportsFilters.start_date = value;
                                    return { reportsFilters };
                                });
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            type="date"
                            label={this.props.t('Lopetuspäivä')}
                            value={this.state.reportsFilters.end_date}
                            onChange={(event) => {
                                const value = event.target.value;
                                this.setState(prevState => {
                                    let reportsFilters = Object.assign({}, prevState.reportsFilters);
                                    reportsFilters.end_date = value;
                                    return { reportsFilters };
                                });
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            select
                            label={this.props.t('Ravintola')}
                            value={this.state.reportsFilters.restaurantId}
                            onChange={(event) => this.setState(prevState => {
                                let reportsFilters = Object.assign({}, prevState.reportsFilters);
                                reportsFilters.restaurantId = event.target.value;
                                return { reportsFilters };
                            })}
                            InputLabelProps={{
                                shrink: true,
                            }}

                        >
                            <MenuItem key={0} value={false}>
                                {this.props.t('Kaikki ravintolat')}
                            </MenuItem>

                            {this.state.restaurants.map(restaurant => (
                                <MenuItem key={restaurant.id} value={restaurant.id}>
                                    {restaurant.name}
                                </MenuItem>
                            ))};
                        </TextField>
                    </Grid>

                    <Grid item xs={3} style={{ alignSelf: 'center' }}>
                        <Button
                            fullWidth
                            variant="raised"
                            color="primary"
                            onClick={() => {
                                this.setState(prevState => ({
                                    reportsFilters: {
                                        ...prevState.reportsFilters,
                                        pageNumber: 0,
                                        missedPageNumber: 0,
                                    },
                                    loading: true,
                                }), this.filterReports);
                            }}
                        >{this.props.t('Hae')}</Button>
                    </Grid>
                </Grid>
            </div>
        );

        return (
            <PaddedGrid>
                <Grid item xs={12}>
                    <Typography variant="title">
                        {this.props.t('Ruokahävikin kirjaussovellus')}
                    </Typography>
                </Grid>

                {this.state.error ? <Typography color="error" variant="subheading">{this.state.error}</Typography> : ''}

                {reportStarter}

                {!AppContext.isUser() && reportFinder}

                {this.renderMissedReports()}

                <Grid item xs={12}>
                    <Typography variant="title" gutterBottom>{this.props.t('Raportit')}</Typography>
                    <ReportsList
                        rowsPerPage={this.state.reportsFilters.displayCount}
                        page={this.state.reportsFilters.pageNumber}
                        reports={this.state.reports}
                        totalReportsCount={this.state.totalReportCount}
                        reportsToDisplay={this.state.reportsFilters.displayCount}
                        onReportsToDisplayChange={this.onReportsToDisplayChange.bind(this, false)}
                        changePageNumber={this.changePageNumber.bind(this, false)}
                    />
                </Grid>
            </PaddedGrid>
        );
    }
}
export default withTranslation()(Home);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Home.js